<template>
  <v-flex class="messages">
    <v-layout align-center> <h1>Messages</h1> </v-layout>
    <v-card>
      <v-list v-if="loaded" two-line class="mt-3 pt-0 pb-0">
        <template v-for="(message, index) in messages">
          <v-list-item :key="message.id" @click.stop="openMessage(message)">
            <v-tooltip v-if="message.pinned" top color="error">
              <template v-slot:activator="{ on }">
                <v-list-item-avatar class="mr-3" v-on="on">
                  <div @click.stop>
                    <v-btn
                      icon
                      color="primary"
                      text
                      @click="openUnpinDialog(message)"
                    >
                      <svg
                        width="20"
                        height="20"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 489.493 489.493"
                        style="enable-background:new 0 0 489.493 489.493;"
                      >
                        <path
                          fill="currentColor"
                          d="M485.322,117.705c12.204-12.238-3.274-47.577-34.636-78.93c-30.99-30.99-65.76-46.396-78.401-34.941l-0.246-0.236l-173.715,156.02c-32.117-27.993-80.684-27.038-111.278,3.534c-5.149,5.157-8.051,12.146-8.051,19.437c0,7.292,2.901,14.283,8.051,19.431l78.808,78.801L3.902,463.627c-5.148,5.799-5.262,14.655,0.015,20.601c5.689,6.403,15.497,6.992,21.916,1.294l182.575-162.137l7.84,7.829l40.601,40.603l0,0l30.336,30.329c5.15,5.147,12.139,8.039,19.424,8.039c7.278,0,14.272-2.898,19.419-8.056c30.561-30.573,31.524-79.158,3.539-111.27L484.771,118.03C484.927,117.892,485.177,117.861,485.322,117.705z"
                        />
                      </svg>
                    </v-btn>
                  </div>
                </v-list-item-avatar>
              </template>
              <span>Unpin message</span>
            </v-tooltip>
            <v-list-item-avatar class="mr-3">
              <img :src="message.user.avatar_url" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ message.title }}</v-list-item-title>
              <v-list-item-subtitle
                ><span class="text--primary">{{
                  getNameFromUser(message.user)
                }}</span>
                &mdash; {{ message.message }}</v-list-item-subtitle
              >
            </v-list-item-content>

            <v-list-item-action>
              <div @click.stop>
                <v-menu
                  bottom
                  left
                  transition="slide-y-transition"
                  min-width="150"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on"> <v-icon>more_vert</v-icon> </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item
                      @click.stop="
                        message.pinned
                          ? openUnpinDialog(message)
                          : openPinDialog(message)
                      "
                    >
                      <svg
                        width="22"
                        class="v-icon mr-2 theme--light"
                        height="18"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 489.493 489.493"
                        style="enable-background:new 0 0 489.493 489.493; flex-shrink: 0"
                      >
                        <path
                          fill="currentColor"
                          d="M485.322,117.705c12.204-12.238-3.274-47.577-34.636-78.93c-30.99-30.99-65.76-46.396-78.401-34.941l-0.246-0.236l-173.715,156.02c-32.117-27.993-80.684-27.038-111.278,3.534c-5.149,5.157-8.051,12.146-8.051,19.437c0,7.292,2.901,14.283,8.051,19.431l78.808,78.801L3.902,463.627c-5.148,5.799-5.262,14.655,0.015,20.601c5.689,6.403,15.497,6.992,21.916,1.294l182.575-162.137l7.84,7.829l40.601,40.603l0,0l30.336,30.329c5.15,5.147,12.139,8.039,19.424,8.039c7.278,0,14.272-2.898,19.419-8.056c30.561-30.573,31.524-79.158,3.539-111.27L484.771,118.03C484.927,117.892,485.177,117.861,485.322,117.705z"
                        />
                      </svg>
                      <v-list-item-title>{{
                        message.pinned ? 'Unpin' : 'Pin'
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click.stop="openDeleteDialog(message)">
                      <v-icon class="mr-2">delete</v-icon>
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </v-list-item-action>
          </v-list-item>
          <v-divider
            v-if="index + 1 < messages.length"
            :key="index"
          ></v-divider>
        </template>
      </v-list>
      <v-alert
        v-if="messages.length === 0 && loaded"
        :value="true"
        type="info"
        color="primary"
        outlined
      >
        There are no messages to display
      </v-alert>
    </v-card>

    <v-progress-linear
      v-if="!loaded"
      color="info"
      :indeterminate="true"
      class="mt-3"
    />

    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-app-bar flat dark color="primary">
          <v-toolbar-title>Are you sure?</v-toolbar-title>
        </v-app-bar>
        <v-card-text>
          If you delete this message it will be gone forever, along with any
          comments.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="error" :loading="loadingDelete" @click="deleteMessage()"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="pinDialog" persistent max-width="330">
      <v-card>
        <v-app-bar flat dark color="primary">
          <v-toolbar-title>Are you sure?</v-toolbar-title>
        </v-app-bar>
        <v-card-text>
          Are you sure you would like to pin this message?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="error" text @click="pinDialog = false">Cancel</v-btn>
          <v-btn color="success" :loading="loadingPin" @click="pinMessage()"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="unpinDialog" persistent max-width="290">
      <v-card>
        <v-app-bar flat dark color="primary">
          <v-toolbar-title>Are you sure?</v-toolbar-title>
        </v-app-bar>
        <v-card-text>
          Are you sure you would like to unpin this message?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="error" text @click="unpinDialog = false">Cancel</v-btn>
          <v-btn color="success" :loading="loadingUnpin" @click="unpinMessage()"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="messageDialog" max-width="600px">
      <v-card>
        <view-message v-if="messageDialog" :message="currentMessage" />
        <v-card-actions class="pt-0">
          <v-spacer />
          <v-btn color="primary" @click="messageDialog = false"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import { messagesCollection } from '../firebaseConfig.js';
import ViewMessage from '@/components/ViewMessage';
import getNameFromUser from '@/helpers/getNameFromUser.js';

export default {
  name: 'Messages',
  components: {
    ViewMessage
  },
  data() {
    return {
      loaded: false,
      messages: [],
      deleteDialog: false,
      messageDialog: false,
      pinDialog: false,
      unpinDialog: false,
      currentMessage: null,
      loadingPin: false,
      loadingUnpin: false,
      loadingDelete: false
    };
  },
  computed: {
    currentLocationId() {
      return this.$store.state.currentLocation.id;
    }
  },
  mounted() {
    this.getMessages();
  },
  methods: {
    getNameFromUser,
    openMessage(message) {
      this.currentMessage = message;
      this.messageDialog = true;
    },
    getMessages() {
      this.$bind(
        'messages',
        messagesCollection
          .where('location_id', '==', this.currentLocationId)
          .orderBy('pinned', 'desc')
          .orderBy('timestamp', 'desc')
      )
        .then(() => {
          this.loaded = true;
        })
        .catch(error => {
          this.$store.dispatch('createSnackbar', {
            color: 'error',
            text: `Error loading messages: ${error}`
          });
        });
    },
    openDeleteDialog(message) {
      this.currentMessage = message;
      this.deleteDialog = true;
    },
    openPinDialog(message) {
      this.currentMessage = message;
      this.pinDialog = true;
    },
    openUnpinDialog(message) {
      this.currentMessage = message;
      this.unpinDialog = true;
    },
    deleteMessage() {
      this.loadingDelete = true;
      messagesCollection
        .doc(this.currentMessage.id)
        .delete()
        .then(() => {
          this.deleteDialog = false;
          this.$store.dispatch('createSnackbar', {
            color: 'success',
            text: `Message deleted successfully`
          });
        })
        .catch(error => {
          this.deleteDialog = false;
          this.$store.dispatch('createSnackbar', {
            color: 'error',
            text: `Error deleting message: ${error}`
          });
        })
        .finally(() => {
          this.loadingDelete = false;
        });
    },
    pinMessage() {
      this.loadingPin = true;
      messagesCollection
        .doc(this.currentMessage.id)
        .update({
          pinned: true
        })
        .then(() => {
          this.pinDialog = false;
          this.$store.dispatch('createSnackbar', {
            color: 'success',
            text: `Message pinned successfully`
          });
        })
        .catch(error => {
          this.pinDialog = false;
          this.$store.dispatch('createSnackbar', {
            color: 'error',
            text: `Error pinning message: ${error}`
          });
        })
        .finally(() => {
          this.loadingPin = false;
        });
    },
    unpinMessage() {
      this.loadingUnpin = true;
      messagesCollection
        .doc(this.currentMessage.id)
        .update({
          pinned: false
        })
        .then(() => {
          this.unpinDialog = false;
          this.$store.dispatch('createSnackbar', {
            color: 'success',
            text: `Message un-pinned successfully`
          });
        })
        .catch(error => {
          this.unpinDialog = false;
          this.$store.dispatch('createSnackbar', {
            color: 'error',
            text: `Error un-pinning message: ${error}`
          });
        })
        .finally(() => {
          this.loadingUnpin = false;
        });
    }
  }
};
</script>
